module.exports = __webpack_public_path__ + "vennProvidedLogoGreyscale.36080577055a2761b75fed4f5f26e81b.png";